import { DivTooltip } from '@wg/wows-react-uikit';
import equal from 'fast-deep-equal/react';
import classnames from 'classnames';
import { memo } from 'react';
import styles from './RewardShip.scss';
import type { IReward } from '~/types';
import type { RootState } from '~/store';
import Rays from '~/Components/Rays/Rays';
import RewardShipTooltip from '~/Components/Tooltips/RewardShipTooltip/RewardShipTooltip';
import { REWARD_COLORS } from '~/constants';
import { ship } from '~/wowsEntities';
import { useAppDispatch, useAppSelector } from '~/hooks';
import { openShipFeaturesDialog } from '~/store/dialogs';


interface IState {
    mainRewardShipId: string,
    shipPreviewBackground: string | null,
    secondaryShipPreviewBackground: string | null,
}

const stateSelector = (state: RootState): IState => {
    return {
        mainRewardShipId: state.app.mainRewardShipId,
        shipPreviewBackground: state.app.shipPreviewBackground,
        secondaryShipPreviewBackground: state.app.secondaryShipPreviewBackground,
    };
};

export interface RewardShip_Props {
    id: string,
    isCollected?: boolean,
    isPremium?: boolean,
    fixedTooltip?: boolean,
    raysVisible?: boolean,
    reward?: IReward,
    isBig?: boolean,
    clickableVehicles?: boolean,
}

const RewardShip = (props: RewardShip_Props) => {
    const state = useAppSelector(stateSelector, equal);
    const dispatch = useAppDispatch();

    const {
        id, isCollected, isPremium, fixedTooltip, raysVisible, reward, isBig, clickableVehicles
    } = props;
    const { mainRewardShipId, shipPreviewBackground, secondaryShipPreviewBackground } = state;

    const wrapper = classnames(styles.wrapper, {
        [styles.wrapperBig]: !!isBig,
    });

    const back = classnames(styles.image, styles.shipBack, {
        [styles.imageBig]: !!isBig,
    });
    const backStyles = {
        backgroundImage: `url(${reward?.flagImage})`,
    };

    const front = classnames(styles.image, {
        [styles.imageBig]: !!isBig,
    });
    const frontStyles = {
        backgroundImage: `url(${reward?.image})`,
    };

    const raysHolder = classnames(styles.raysHolder, {
        [styles.raysHolderVisible]: !!raysVisible,
    });

    const openShipFeatures = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(openShipFeaturesDialog(Number(id)));
    };

    const renderShipNameHolder = () => {
        const isMainReward = id === mainRewardShipId;
        const previewBackground = isMainReward ? shipPreviewBackground : secondaryShipPreviewBackground;

        return ship(
            id,
            false,
            clickableVehicles && previewBackground
                ? openShipFeatures
                : undefined,
            true
        );
    };

    return (
        <DivTooltip
            fixed={!!fixedTooltip}
            position={'top'}
            tooltipBody={<RewardShipTooltip id={id} reward={reward} isCollected={isCollected} isPremium={isPremium} />}
        >
            <div className={wrapper}>
                <div className={back} style={backStyles} />
                <div className={raysHolder}>
                    <Rays className={styles.rays} color={REWARD_COLORS.YELLOW} />
                </div>
                <div className={front} style={frontStyles} />
                <div className={styles.shipNameHolder}>{renderShipNameHolder()}</div>
            </div>
        </DivTooltip>
    );
};

export default memo(RewardShip);
